module.exports = __webpack_public_path__ + "img/kcjzh.d3a93887.png";